interface InfoTooltipProps {
  content: string;
  label?: string;
}

export function InfoTooltip({ content, label = "Informazioni" }: InfoTooltipProps) {
  return (
    <details className="info-tooltip">
      <summary aria-label={label} title={label}>
        i
      </summary>
      <div role="tooltip">{content}</div>
    </details>
  );
}
